import { put, select } from 'redux-saga/effects';
import { getOrderTiming } from '../../../../../util/orderTiming';
import { toggleGlobalLoaderQueue } from '../../../reducers/ducks/legacy/MainDuck';
import Notification from '../../../../../components/layout/Notification';

export default function* orderTimingGuard(payment, expectedKey) {
  const timing = yield select((state) => getOrderTiming(state));
  if (
    !timing.requiresConfirmation &&
    (!payment || timing.checkoutMatches) &&
    (expectedKey === undefined || timing.key === expectedKey)
  )
    return true;
  yield put(toggleGlobalLoaderQueue({ name: 'checkout', status: false }));
  let message =
    'Your order time changed. Please refresh checkout before paying.';
  if (timing.requiresConfirmation)
    message = 'Please choose and confirm your order time before continuing.';
  if (expectedKey !== undefined && timing.key !== expectedKey)
    message = 'The order time changed. Review the order time and try again.';
  Notification.info(message, { toastId: 'ConfirmOrderTime' });
  return false;
}
